import { Box, Button, Chip, Grid, Hidden, Typography } from "@mui/material";
import { getEntryStatusColor } from "../common/VisualElementsHelper";
import { useSelector } from "react-redux";
import React from "react";
import { Enumerations } from "../../config/Enumerations";

export default function ReviewStatusesPanel({ appReview }) {
  const auth = useSelector((state) => state.auth);

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            flexDirection: {
              xs: "column",
              md: "row",
            },
            alignItems: {
              xs: "flex-start",
              md: "flex-start",
            },
            textAlign: {
              xs: "center",
              md: "left",
            },
          }}
        >
          <Button
            disabled
            sx={{
              cursor: "default",
              display: "inline-flex",
              backgroundColor: getEntryStatusColor(appReview?.reviewStatus),
              color: "#fff",
              borderRadius: 0,
              textTransform: "none",
              fontSize: 15,
              fontFamily: "Inter-Regular",
              justifyContent: "center",
              alignItems: "center",
              "&:hover": {
                backgroundColor: getEntryStatusColor(appReview?.reviewStatus),
              },
              "&.Mui-disabled": {
                color: "white",
                opacity: 1,
              },
            }}
          >
            {Enumerations.AppReviewStatus[appReview?.reviewStatus]}
          </Button>

          {appReview?.instArchiveNumber && (
            <Chip
              variant="outlined"
              color="primary"
              label={`Архивски број на институција: ${appReview?.instArchiveNumber}`}
            />
          )}

          {appReview?.appEntry?.archiveNumber && (
            <Chip
              color="success"
              variant="outlined"
              label={`Архивски број на Министерство за транспорт: ${appReview?.appEntry?.archiveNumber}`}
            />
          )}

          {appReview?.assignedTo && (
            <Chip
              color="warning"
              variant="filled"
              label={`Доделен на: ${appReview?.assignedTo?.firstName} ${appReview?.assignedTo?.lastName}`}
            />
          )}
        </Box>
      </Grid>
    </React.Fragment>
  );
}
